import * as React from 'react';
import ModalContainer from 'react-modal-promise';
import {Outlet, useMatch, useNavigate} from 'react-router';

import {ChromeHeaderReact} from 'common/widgets/chrome/chrome-header';
import {ReportMessageBannerReact} from 'common/widgets/report-message-banner';
import {ReportBannersReact} from 'common/widgets/report-banners';
import {useCurrentProject} from 'common/contexts/react/current-project-context';
import {useThemes} from 'common/contexts/react/themes-context';
import {isChartCustomizationEnabled} from 'common/query-builder/chart-customization/utils';
import {isBoardsToReportsEnabled} from 'common/report/util';

// Header Layout is used for all apps except for `public` and `dashboard-digest`
export const ChromeHeaderLayout: React.FC<EmptyObj> = () => {
  const navigate = useNavigate();
  // for spa mode + rewrite hash -> pathname, we need more specific handling for url like app/{appName}/nested/routes
  const isEmbedMode = useMatch(`/project/:projectId/view?/:workspaceId?/app/:appName/embed/*`);
  const currentProject = useCurrentProject();
  const themesResource = useThemes();
  if (isChartCustomizationEnabled(currentProject.get().value)) {
    themesResource.getAll();
  }

  if (isEmbedMode) {
    return (
      <div id='mixpanel-application'>
        <Outlet />
      </div>
    );
  }

  const isBoardsToReportsEnabledVal = Boolean(isBoardsToReportsEnabled(currentProject.get().value));

  return (
    <>
      {/* mp-chrome-header uses shadow dom, so all its children will be in #shadow-root including styles */}
      {/* since we defer all js, these shell styles will be drawn as soon as css loads */}
      <ChromeHeaderReact navigate={navigate} />
      <div className={`below_header`}>
        <div id='width_wrapper'>
          <div id='report'>
            <div id='report_content' className='mp-chrome-report-content'>
              {!isBoardsToReportsEnabledVal && (
                <div id='messages'>
                  <ReportMessageBannerReact />
                  <ReportBannersReact />
                </div>
              )}
              <div id='padding_wrapper'>
                <div id='mixpanel-application'>
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
          <div id='modals' />
          <ModalContainer />
        </div>
      </div>
    </>
  );
};
